module.exports = __webpack_public_path__ + "img/mobile-spectrum-CMMC.07d06eb4.png";